import { Navigate, Route, Routes } from "react-router-dom";

import { navRoutes } from "functions/navFuncs";
import LoginPage from "pages/LoginPage";
import PageLayout from "layouts/PageLayout";
import PrivateLayout from "layouts/PrivateLayout";
import PublicLayout from "layouts/PublicLayout";

const AppRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/">
          <Route element={<PublicLayout />}>
            <Route path="login" element={<LoginPage />} />
          </Route>
          <Route element={<PrivateLayout />}>
            <Route element={<PageLayout />}>
              {navRoutes.map((navRoute, index) => (
                <Route key={index} {...navRoute} />
              ))}
            </Route>
          </Route>
          <Route index element={<Navigate to="/login" />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
